import React from 'react';
import { Link } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <div
      role="main"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        gap: '1rem',
      }}
    >
      <h1 style={{ fontSize: '4rem', margin: 0 }}>404</h1>
      <p style={{ fontSize: '1.125rem', maxWidth: 480 }}>
        Cette page n'existe pas ou a été déplacée.
      </p>
      <div style={{ display: 'flex', gap: '0.75rem' }}>
        <Link
          to="/dashboard"
          style={{
            padding: '0.6rem 1.2rem',
            borderRadius: 8,
            background: 'var(--color-primary, #4f46e5)',
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          Retour au tableau de bord
        </Link>
        <Link
          to="/editor"
          style={{
            padding: '0.6rem 1.2rem',
            borderRadius: 8,
            border: '1px solid currentColor',
            textDecoration: 'none',
          }}
        >
          Ouvrir l'éditeur
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
